import { render, staticRenderFns } from "./BancaEmaticaEdit.vue?vue&type=template&id=04f901b4"
import script from "./BancaEmaticaEdit.vue?vue&type=script&lang=js"
export * from "./BancaEmaticaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports